// Protocol Buffers - Google's data interchange format
// Copyright 2008 Google Inc.  All rights reserved.
// https://developers.google.com/protocol-buffers/
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// Author: kenton@google.com (Kenton Varda)
//  Based on original Protocol Buffers design by
//  Sanjay Ghemawat, Jeff Dean, and others.
//
// The messages in this file describe the definitions found in .proto files.
// A valid .proto file can be translated directly to a FileDescriptorProto
// without any other information (e.g. without reading its imports).

// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file google/protobuf/descriptor.proto (package google.protobuf, syntax proto2)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { enumDesc, fileDesc, messageDesc, tsEnum } = require("@bufbuild/protobuf/codegenv2");

/**
 * Describes the file google/protobuf/descriptor.proto.
 */
const file_google_protobuf_descriptor = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message google.protobuf.FileDescriptorSet.
 * Use `create(FileDescriptorSetSchema)` to create a new message.
 */
const FileDescriptorSetSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 0);

/**
 * Describes the message google.protobuf.FileDescriptorProto.
 * Use `create(FileDescriptorProtoSchema)` to create a new message.
 */
const FileDescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 1);

/**
 * Describes the message google.protobuf.DescriptorProto.
 * Use `create(DescriptorProtoSchema)` to create a new message.
 */
const DescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 2);

/**
 * Describes the message google.protobuf.DescriptorProto.ExtensionRange.
 * Use `create(DescriptorProto_ExtensionRangeSchema)` to create a new message.
 */
const DescriptorProto_ExtensionRangeSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 2, 0);

/**
 * Describes the message google.protobuf.DescriptorProto.ReservedRange.
 * Use `create(DescriptorProto_ReservedRangeSchema)` to create a new message.
 */
const DescriptorProto_ReservedRangeSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 2, 1);

/**
 * Describes the message google.protobuf.ExtensionRangeOptions.
 * Use `create(ExtensionRangeOptionsSchema)` to create a new message.
 */
const ExtensionRangeOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 3);

/**
 * Describes the message google.protobuf.ExtensionRangeOptions.Declaration.
 * Use `create(ExtensionRangeOptions_DeclarationSchema)` to create a new message.
 */
const ExtensionRangeOptions_DeclarationSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 3, 0);

/**
 * Describes the enum google.protobuf.ExtensionRangeOptions.VerificationState.
 */
const ExtensionRangeOptions_VerificationStateSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 3, 0);

/**
 * The verification state of the extension range.
 *
 * @generated from enum google.protobuf.ExtensionRangeOptions.VerificationState
 */
const ExtensionRangeOptions_VerificationState = /*@__PURE__*/
  tsEnum(ExtensionRangeOptions_VerificationStateSchema);

/**
 * Describes the message google.protobuf.FieldDescriptorProto.
 * Use `create(FieldDescriptorProtoSchema)` to create a new message.
 */
const FieldDescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 4);

/**
 * Describes the enum google.protobuf.FieldDescriptorProto.Type.
 */
const FieldDescriptorProto_TypeSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 4, 0);

/**
 * @generated from enum google.protobuf.FieldDescriptorProto.Type
 */
const FieldDescriptorProto_Type = /*@__PURE__*/
  tsEnum(FieldDescriptorProto_TypeSchema);

/**
 * Describes the enum google.protobuf.FieldDescriptorProto.Label.
 */
const FieldDescriptorProto_LabelSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 4, 1);

/**
 * @generated from enum google.protobuf.FieldDescriptorProto.Label
 */
const FieldDescriptorProto_Label = /*@__PURE__*/
  tsEnum(FieldDescriptorProto_LabelSchema);

/**
 * Describes the message google.protobuf.OneofDescriptorProto.
 * Use `create(OneofDescriptorProtoSchema)` to create a new message.
 */
const OneofDescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 5);

/**
 * Describes the message google.protobuf.EnumDescriptorProto.
 * Use `create(EnumDescriptorProtoSchema)` to create a new message.
 */
const EnumDescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 6);

/**
 * Describes the message google.protobuf.EnumDescriptorProto.EnumReservedRange.
 * Use `create(EnumDescriptorProto_EnumReservedRangeSchema)` to create a new message.
 */
const EnumDescriptorProto_EnumReservedRangeSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 6, 0);

/**
 * Describes the message google.protobuf.EnumValueDescriptorProto.
 * Use `create(EnumValueDescriptorProtoSchema)` to create a new message.
 */
const EnumValueDescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 7);

/**
 * Describes the message google.protobuf.ServiceDescriptorProto.
 * Use `create(ServiceDescriptorProtoSchema)` to create a new message.
 */
const ServiceDescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 8);

/**
 * Describes the message google.protobuf.MethodDescriptorProto.
 * Use `create(MethodDescriptorProtoSchema)` to create a new message.
 */
const MethodDescriptorProtoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 9);

/**
 * Describes the message google.protobuf.FileOptions.
 * Use `create(FileOptionsSchema)` to create a new message.
 */
const FileOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 10);

/**
 * Describes the enum google.protobuf.FileOptions.OptimizeMode.
 */
const FileOptions_OptimizeModeSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 10, 0);

/**
 * Generated classes can be optimized for speed or code size.
 *
 * @generated from enum google.protobuf.FileOptions.OptimizeMode
 */
const FileOptions_OptimizeMode = /*@__PURE__*/
  tsEnum(FileOptions_OptimizeModeSchema);

/**
 * Describes the message google.protobuf.MessageOptions.
 * Use `create(MessageOptionsSchema)` to create a new message.
 */
const MessageOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 11);

/**
 * Describes the message google.protobuf.FieldOptions.
 * Use `create(FieldOptionsSchema)` to create a new message.
 */
const FieldOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 12);

/**
 * Describes the message google.protobuf.FieldOptions.EditionDefault.
 * Use `create(FieldOptions_EditionDefaultSchema)` to create a new message.
 */
const FieldOptions_EditionDefaultSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 12, 0);

/**
 * Describes the message google.protobuf.FieldOptions.FeatureSupport.
 * Use `create(FieldOptions_FeatureSupportSchema)` to create a new message.
 */
const FieldOptions_FeatureSupportSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 12, 1);

/**
 * Describes the enum google.protobuf.FieldOptions.CType.
 */
const FieldOptions_CTypeSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 12, 0);

/**
 * @generated from enum google.protobuf.FieldOptions.CType
 */
const FieldOptions_CType = /*@__PURE__*/
  tsEnum(FieldOptions_CTypeSchema);

/**
 * Describes the enum google.protobuf.FieldOptions.JSType.
 */
const FieldOptions_JSTypeSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 12, 1);

/**
 * @generated from enum google.protobuf.FieldOptions.JSType
 */
const FieldOptions_JSType = /*@__PURE__*/
  tsEnum(FieldOptions_JSTypeSchema);

/**
 * Describes the enum google.protobuf.FieldOptions.OptionRetention.
 */
const FieldOptions_OptionRetentionSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 12, 2);

/**
 * If set to RETENTION_SOURCE, the option will be omitted from the binary.
 *
 * @generated from enum google.protobuf.FieldOptions.OptionRetention
 */
const FieldOptions_OptionRetention = /*@__PURE__*/
  tsEnum(FieldOptions_OptionRetentionSchema);

/**
 * Describes the enum google.protobuf.FieldOptions.OptionTargetType.
 */
const FieldOptions_OptionTargetTypeSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 12, 3);

/**
 * This indicates the types of entities that the field may apply to when used
 * as an option. If it is unset, then the field may be freely used as an
 * option on any kind of entity.
 *
 * @generated from enum google.protobuf.FieldOptions.OptionTargetType
 */
const FieldOptions_OptionTargetType = /*@__PURE__*/
  tsEnum(FieldOptions_OptionTargetTypeSchema);

/**
 * Describes the message google.protobuf.OneofOptions.
 * Use `create(OneofOptionsSchema)` to create a new message.
 */
const OneofOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 13);

/**
 * Describes the message google.protobuf.EnumOptions.
 * Use `create(EnumOptionsSchema)` to create a new message.
 */
const EnumOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 14);

/**
 * Describes the message google.protobuf.EnumValueOptions.
 * Use `create(EnumValueOptionsSchema)` to create a new message.
 */
const EnumValueOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 15);

/**
 * Describes the message google.protobuf.ServiceOptions.
 * Use `create(ServiceOptionsSchema)` to create a new message.
 */
const ServiceOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 16);

/**
 * Describes the message google.protobuf.MethodOptions.
 * Use `create(MethodOptionsSchema)` to create a new message.
 */
const MethodOptionsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 17);

/**
 * Describes the enum google.protobuf.MethodOptions.IdempotencyLevel.
 */
const MethodOptions_IdempotencyLevelSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 17, 0);

/**
 * Is this method side-effect-free (or safe in HTTP parlance), or idempotent,
 * or neither? HTTP based RPC implementation may choose GET verb for safe
 * methods, and PUT verb for idempotent methods instead of the default POST.
 *
 * @generated from enum google.protobuf.MethodOptions.IdempotencyLevel
 */
const MethodOptions_IdempotencyLevel = /*@__PURE__*/
  tsEnum(MethodOptions_IdempotencyLevelSchema);

/**
 * Describes the message google.protobuf.UninterpretedOption.
 * Use `create(UninterpretedOptionSchema)` to create a new message.
 */
const UninterpretedOptionSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 18);

/**
 * Describes the message google.protobuf.UninterpretedOption.NamePart.
 * Use `create(UninterpretedOption_NamePartSchema)` to create a new message.
 */
const UninterpretedOption_NamePartSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 18, 0);

/**
 * Describes the message google.protobuf.FeatureSet.
 * Use `create(FeatureSetSchema)` to create a new message.
 */
const FeatureSetSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 19);

/**
 * Describes the message google.protobuf.FeatureSet.VisibilityFeature.
 * Use `create(FeatureSet_VisibilityFeatureSchema)` to create a new message.
 */
const FeatureSet_VisibilityFeatureSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 19, 0);

/**
 * Describes the enum google.protobuf.FeatureSet.VisibilityFeature.DefaultSymbolVisibility.
 */
const FeatureSet_VisibilityFeature_DefaultSymbolVisibilitySchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 0, 0);

/**
 * @generated from enum google.protobuf.FeatureSet.VisibilityFeature.DefaultSymbolVisibility
 */
const FeatureSet_VisibilityFeature_DefaultSymbolVisibility = /*@__PURE__*/
  tsEnum(FeatureSet_VisibilityFeature_DefaultSymbolVisibilitySchema);

/**
 * Describes the enum google.protobuf.FeatureSet.FieldPresence.
 */
const FeatureSet_FieldPresenceSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 0);

/**
 * @generated from enum google.protobuf.FeatureSet.FieldPresence
 */
const FeatureSet_FieldPresence = /*@__PURE__*/
  tsEnum(FeatureSet_FieldPresenceSchema);

/**
 * Describes the enum google.protobuf.FeatureSet.EnumType.
 */
const FeatureSet_EnumTypeSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 1);

/**
 * @generated from enum google.protobuf.FeatureSet.EnumType
 */
const FeatureSet_EnumType = /*@__PURE__*/
  tsEnum(FeatureSet_EnumTypeSchema);

/**
 * Describes the enum google.protobuf.FeatureSet.RepeatedFieldEncoding.
 */
const FeatureSet_RepeatedFieldEncodingSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 2);

/**
 * @generated from enum google.protobuf.FeatureSet.RepeatedFieldEncoding
 */
const FeatureSet_RepeatedFieldEncoding = /*@__PURE__*/
  tsEnum(FeatureSet_RepeatedFieldEncodingSchema);

/**
 * Describes the enum google.protobuf.FeatureSet.Utf8Validation.
 */
const FeatureSet_Utf8ValidationSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 3);

/**
 * @generated from enum google.protobuf.FeatureSet.Utf8Validation
 */
const FeatureSet_Utf8Validation = /*@__PURE__*/
  tsEnum(FeatureSet_Utf8ValidationSchema);

/**
 * Describes the enum google.protobuf.FeatureSet.MessageEncoding.
 */
const FeatureSet_MessageEncodingSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 4);

/**
 * @generated from enum google.protobuf.FeatureSet.MessageEncoding
 */
const FeatureSet_MessageEncoding = /*@__PURE__*/
  tsEnum(FeatureSet_MessageEncodingSchema);

/**
 * Describes the enum google.protobuf.FeatureSet.JsonFormat.
 */
const FeatureSet_JsonFormatSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 5);

/**
 * @generated from enum google.protobuf.FeatureSet.JsonFormat
 */
const FeatureSet_JsonFormat = /*@__PURE__*/
  tsEnum(FeatureSet_JsonFormatSchema);

/**
 * Describes the enum google.protobuf.FeatureSet.EnforceNamingStyle.
 */
const FeatureSet_EnforceNamingStyleSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 19, 6);

/**
 * @generated from enum google.protobuf.FeatureSet.EnforceNamingStyle
 */
const FeatureSet_EnforceNamingStyle = /*@__PURE__*/
  tsEnum(FeatureSet_EnforceNamingStyleSchema);

/**
 * Describes the message google.protobuf.FeatureSetDefaults.
 * Use `create(FeatureSetDefaultsSchema)` to create a new message.
 */
const FeatureSetDefaultsSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 20);

/**
 * Describes the message google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault.
 * Use `create(FeatureSetDefaults_FeatureSetEditionDefaultSchema)` to create a new message.
 */
const FeatureSetDefaults_FeatureSetEditionDefaultSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 20, 0);

/**
 * Describes the message google.protobuf.SourceCodeInfo.
 * Use `create(SourceCodeInfoSchema)` to create a new message.
 */
const SourceCodeInfoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 21);

/**
 * Describes the message google.protobuf.SourceCodeInfo.Location.
 * Use `create(SourceCodeInfo_LocationSchema)` to create a new message.
 */
const SourceCodeInfo_LocationSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 21, 0);

/**
 * Describes the message google.protobuf.GeneratedCodeInfo.
 * Use `create(GeneratedCodeInfoSchema)` to create a new message.
 */
const GeneratedCodeInfoSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 22);

/**
 * Describes the message google.protobuf.GeneratedCodeInfo.Annotation.
 * Use `create(GeneratedCodeInfo_AnnotationSchema)` to create a new message.
 */
const GeneratedCodeInfo_AnnotationSchema = /*@__PURE__*/
  messageDesc(file_google_protobuf_descriptor, 22, 0);

/**
 * Describes the enum google.protobuf.GeneratedCodeInfo.Annotation.Semantic.
 */
const GeneratedCodeInfo_Annotation_SemanticSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 22, 0, 0);

/**
 * Represents the identified object's effect on the element in the original
 * .proto file.
 *
 * @generated from enum google.protobuf.GeneratedCodeInfo.Annotation.Semantic
 */
const GeneratedCodeInfo_Annotation_Semantic = /*@__PURE__*/
  tsEnum(GeneratedCodeInfo_Annotation_SemanticSchema);

/**
 * Describes the enum google.protobuf.Edition.
 */
const EditionSchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 0);

/**
 * The full set of known editions.
 *
 * @generated from enum google.protobuf.Edition
 */
const Edition = /*@__PURE__*/
  tsEnum(EditionSchema);

/**
 * Describes the enum google.protobuf.SymbolVisibility.
 */
const SymbolVisibilitySchema = /*@__PURE__*/
  enumDesc(file_google_protobuf_descriptor, 1);

/**
 * Describes the 'visibility' of a symbol with respect to the proto import
 * system. Symbols can only be imported when the visibility rules do not prevent
 * it (ex: local symbols cannot be imported).  Visibility modifiers can only set
 * on `message` and `enum` as they are the only types available to be referenced
 * from other files.
 *
 * @generated from enum google.protobuf.SymbolVisibility
 */
const SymbolVisibility = /*@__PURE__*/
  tsEnum(SymbolVisibilitySchema);


exports.file_google_protobuf_descriptor = file_google_protobuf_descriptor;
exports.FileDescriptorSetSchema = FileDescriptorSetSchema;
exports.FileDescriptorProtoSchema = FileDescriptorProtoSchema;
exports.DescriptorProtoSchema = DescriptorProtoSchema;
exports.DescriptorProto_ExtensionRangeSchema = DescriptorProto_ExtensionRangeSchema;
exports.DescriptorProto_ReservedRangeSchema = DescriptorProto_ReservedRangeSchema;
exports.ExtensionRangeOptionsSchema = ExtensionRangeOptionsSchema;
exports.ExtensionRangeOptions_DeclarationSchema = ExtensionRangeOptions_DeclarationSchema;
exports.ExtensionRangeOptions_VerificationStateSchema = ExtensionRangeOptions_VerificationStateSchema;
exports.ExtensionRangeOptions_VerificationState = ExtensionRangeOptions_VerificationState;
exports.FieldDescriptorProtoSchema = FieldDescriptorProtoSchema;
exports.FieldDescriptorProto_TypeSchema = FieldDescriptorProto_TypeSchema;
exports.FieldDescriptorProto_Type = FieldDescriptorProto_Type;
exports.FieldDescriptorProto_LabelSchema = FieldDescriptorProto_LabelSchema;
exports.FieldDescriptorProto_Label = FieldDescriptorProto_Label;
exports.OneofDescriptorProtoSchema = OneofDescriptorProtoSchema;
exports.EnumDescriptorProtoSchema = EnumDescriptorProtoSchema;
exports.EnumDescriptorProto_EnumReservedRangeSchema = EnumDescriptorProto_EnumReservedRangeSchema;
exports.EnumValueDescriptorProtoSchema = EnumValueDescriptorProtoSchema;
exports.ServiceDescriptorProtoSchema = ServiceDescriptorProtoSchema;
exports.MethodDescriptorProtoSchema = MethodDescriptorProtoSchema;
exports.FileOptionsSchema = FileOptionsSchema;
exports.FileOptions_OptimizeModeSchema = FileOptions_OptimizeModeSchema;
exports.FileOptions_OptimizeMode = FileOptions_OptimizeMode;
exports.MessageOptionsSchema = MessageOptionsSchema;
exports.FieldOptionsSchema = FieldOptionsSchema;
exports.FieldOptions_EditionDefaultSchema = FieldOptions_EditionDefaultSchema;
exports.FieldOptions_FeatureSupportSchema = FieldOptions_FeatureSupportSchema;
exports.FieldOptions_CTypeSchema = FieldOptions_CTypeSchema;
exports.FieldOptions_CType = FieldOptions_CType;
exports.FieldOptions_JSTypeSchema = FieldOptions_JSTypeSchema;
exports.FieldOptions_JSType = FieldOptions_JSType;
exports.FieldOptions_OptionRetentionSchema = FieldOptions_OptionRetentionSchema;
exports.FieldOptions_OptionRetention = FieldOptions_OptionRetention;
exports.FieldOptions_OptionTargetTypeSchema = FieldOptions_OptionTargetTypeSchema;
exports.FieldOptions_OptionTargetType = FieldOptions_OptionTargetType;
exports.OneofOptionsSchema = OneofOptionsSchema;
exports.EnumOptionsSchema = EnumOptionsSchema;
exports.EnumValueOptionsSchema = EnumValueOptionsSchema;
exports.ServiceOptionsSchema = ServiceOptionsSchema;
exports.MethodOptionsSchema = MethodOptionsSchema;
exports.MethodOptions_IdempotencyLevelSchema = MethodOptions_IdempotencyLevelSchema;
exports.MethodOptions_IdempotencyLevel = MethodOptions_IdempotencyLevel;
exports.UninterpretedOptionSchema = UninterpretedOptionSchema;
exports.UninterpretedOption_NamePartSchema = UninterpretedOption_NamePartSchema;
exports.FeatureSetSchema = FeatureSetSchema;
exports.FeatureSet_VisibilityFeatureSchema = FeatureSet_VisibilityFeatureSchema;
exports.FeatureSet_VisibilityFeature_DefaultSymbolVisibilitySchema = FeatureSet_VisibilityFeature_DefaultSymbolVisibilitySchema;
exports.FeatureSet_VisibilityFeature_DefaultSymbolVisibility = FeatureSet_VisibilityFeature_DefaultSymbolVisibility;
exports.FeatureSet_FieldPresenceSchema = FeatureSet_FieldPresenceSchema;
exports.FeatureSet_FieldPresence = FeatureSet_FieldPresence;
exports.FeatureSet_EnumTypeSchema = FeatureSet_EnumTypeSchema;
exports.FeatureSet_EnumType = FeatureSet_EnumType;
exports.FeatureSet_RepeatedFieldEncodingSchema = FeatureSet_RepeatedFieldEncodingSchema;
exports.FeatureSet_RepeatedFieldEncoding = FeatureSet_RepeatedFieldEncoding;
exports.FeatureSet_Utf8ValidationSchema = FeatureSet_Utf8ValidationSchema;
exports.FeatureSet_Utf8Validation = FeatureSet_Utf8Validation;
exports.FeatureSet_MessageEncodingSchema = FeatureSet_MessageEncodingSchema;
exports.FeatureSet_MessageEncoding = FeatureSet_MessageEncoding;
exports.FeatureSet_JsonFormatSchema = FeatureSet_JsonFormatSchema;
exports.FeatureSet_JsonFormat = FeatureSet_JsonFormat;
exports.FeatureSet_EnforceNamingStyleSchema = FeatureSet_EnforceNamingStyleSchema;
exports.FeatureSet_EnforceNamingStyle = FeatureSet_EnforceNamingStyle;
exports.FeatureSetDefaultsSchema = FeatureSetDefaultsSchema;
exports.FeatureSetDefaults_FeatureSetEditionDefaultSchema = FeatureSetDefaults_FeatureSetEditionDefaultSchema;
exports.SourceCodeInfoSchema = SourceCodeInfoSchema;
exports.SourceCodeInfo_LocationSchema = SourceCodeInfo_LocationSchema;
exports.GeneratedCodeInfoSchema = GeneratedCodeInfoSchema;
exports.GeneratedCodeInfo_AnnotationSchema = GeneratedCodeInfo_AnnotationSchema;
exports.GeneratedCodeInfo_Annotation_SemanticSchema = GeneratedCodeInfo_Annotation_SemanticSchema;
exports.GeneratedCodeInfo_Annotation_Semantic = GeneratedCodeInfo_Annotation_Semantic;
exports.EditionSchema = EditionSchema;
exports.Edition = Edition;
exports.SymbolVisibilitySchema = SymbolVisibilitySchema;
exports.SymbolVisibility = SymbolVisibility;
